<template>
  <div id="app" :data-variants='variant' :class='appClasses'>
    <main class="main">
      <transition name='fade'>
        <router-view ref='router'></router-view>
      </transition>
    </main>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Stylesheet from './lib/Stylesheet'
export default {
  name: 'App',
  data () {
    return {
      config: {},
      numPages: 0
    }
  },
  provide () {
    return {
      convince: this.$store.getters.convince,
      theme: this.theme
    }
  },
  computed: {
    theme () {
      return this.$store.state.config.theme
    },
    appClasses () {
      return this.$store.state.language.toLowerCase()
    },
    variant: function () {
      return this.$store.state.urlParams.cv
    },
    ...mapState(['index'])
  },
  watch: {
    index (toParam, fromParam) {
      this.$store.dispatch('refreshSession')
      let to = parseInt(toParam)
      let from = parseInt(fromParam)
      if (to === from) {
        return
      }
      if (to > (this.numPages - 1)) {
        return
      }
      if (to === 0 || !this.hasSession()) {
        return this.$router.replace('/')
      }
      //this.$store.commit('setIndex', to)
      this.$router.push('/p/' + to).catch(err => {}) // eslint-disable-line handle-callback-err
      if (from !== to) {
        const currentPage = this.$store.getters.currentPage
        let pageLabel = currentPage.type
        if (currentPage.options.question) {
          pageLabel += ': ' + currentPage.options.question
        }
        this.$store.getters.convince.event({event: 'page_view', label: pageLabel})
      }
    }
  },
  methods: {
    isTouch () {
      return (('ontouchstart' in window) ||
        (navigator.MaxTouchPoints > 0) ||
        (navigator.msMaxTouchPoints > 0)
      )
    },
    notFound: function () {
      console.log('Not found')
    },
    createStylesheet () {
      let themeStyles = './static/themes/' + this.theme.name.toLowerCase() + '.css'
      Stylesheet.addLink(themeStyles)
      let stylesheet = new Stylesheet()
      stylesheet.addRules(this.theme)
      stylesheet.addFonts(this.theme)
      this.$store.commit('setStylesheet', stylesheet)
    },
    onDOMReady () {
      if (this.isTouch()) {
        document.body.classList.add('touch')
      }
    },
    registerExtensions (extensions) {
      for (const key of Object.keys(extensions)) {
        this.$store.state[key] = extensions[key]
      }
    }
  },
  beforeMount () {
    if (typeof window.cogniclick.config === 'undefined') {
      throw new Error('No config found')
    }
  },
  created () {
    if (!this.validateConfig.ok) {
      this.$router.push('/invalid').catch(err => {}) // eslint-disable-line handle-callback-err
      return
    }
    this.$store.dispatch('refreshSession').then(()=>{
      if (this.$store.getters.account) {
        this.$store.getters.convince.event({event: 'open_campaign', account: this.$store.getters.account.id})
      } 
    })
    
    this.config = window.cogniclick.config
    this.$store.commit('entries', this.config.entries)
    this.$store.commit('setCountry', this.config.country || 'GB')
    let translations = typeof this.config.translations !== 'undefined' ? this.config.translations : {}
    let supportedLanguages = typeof this.config.supportedLanguages !== 'undefined' ? this.config.supportedLanguages : ['EN']
    this.$store.commit('setLanguages', {translations: translations, supported: supportedLanguages})
    this.$store.commit('setLanguage', this.config.country || 'GB')
    this.numPages = this.config.pages.length
    this.createStylesheet()
    window.addEventListener('DOMContentLoaded', this.onDOMReady)
    this.$gtag.set({campaignId: window.convinceConfig.campaignId.toString()})
    this.$gtag.set('dimension1', window.convinceConfig.campaignId.toString());
    let event = new CustomEvent("cogniclick-ready", {
        detail: {
          app: this,
        },
        bubbles: true,
        cancelable: true
      }
    );
    document.body.dispatchEvent(event);
  },
  mounted () {
    if (this.config.cookieconsent) {
      window.cookieconsent.initialise(this.config.cookieconsent)
    }
  }
}
</script>

<style lang='scss'>
@import './scss/main';

h1 {
  margin-top:0;
}

</style>
